import { render, staticRenderFns } from "./EmailVerify.vue?vue&type=template&id=35c73a69&scoped=true&"
import script from "./EmailVerify.vue?vue&type=script&lang=js&"
export * from "./EmailVerify.vue?vue&type=script&lang=js&"
import style0 from "./EmailVerify.vue?vue&type=style&index=0&id=35c73a69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c73a69",
  null
  
)

export default component.exports